import { Link } from "react-router-dom";
import { Linkedin, Mail, Phone, Globe, MapPin, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { SERVICES } from "@/data/content";
import { CONTACT } from "@/data/site";

export const Footer = () => (
  <footer data-testid="main-footer" className="bg-[#0B3D2E] text-slate-300">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 lg:py-20 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
      <div className="lg:col-span-1">
        <div className="mb-5"><Logo light /></div>
        <p className="text-sm leading-relaxed text-slate-400 max-w-xs">
          Insurance should be simple. We're here to help you understand your options, answer your questions, and protect what matters most.
        </p>
        <a href={CONTACT.websiteUrl} className="inline-block mt-4 text-sm text-emerald-400 hover:text-emerald-300 transition-colors">{CONTACT.website}</a>
      </div>

      <div>
        <h4 className="text-white font-display font-medium mb-4 text-sm">Services</h4>
        <ul className="space-y-2.5 text-sm">
          {SERVICES.map((s) => (
            <li key={s.slug}>
              <Link to={`/services/${s.slug}`} className="text-slate-400 hover:text-emerald-400 transition-colors">{s.name}</Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h4 className="text-white font-display font-medium mb-4 text-sm">Company</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/about" className="text-slate-400 hover:text-emerald-400 transition-colors">Our Story</Link></li>
          <li><Link to="/knowledge" className="text-slate-400 hover:text-emerald-400 transition-colors">Knowledge Centre</Link></li>
          <li><Link to="/resources" className="text-slate-400 hover:text-emerald-400 transition-colors">Free Resources</Link></li>
          <li><Link to="/journey" className="text-slate-400 hover:text-emerald-400 transition-colors">Get Started</Link></li>
          <li><Link to="/contact" className="text-slate-400 hover:text-emerald-400 transition-colors">Contact</Link></li>
        </ul>
      </div>

      <div>
        <h4 className="text-white font-display font-medium mb-4 text-sm">Get in touch</h4>
        <ul className="space-y-3 text-sm text-slate-400">
          <li><a href={CONTACT.phoneHref} className="flex items-center gap-2.5 hover:text-emerald-400 transition-colors"><Phone size={16} className="text-emerald-400" /> {CONTACT.phone}</a></li>
          <li><a href={CONTACT.emailHref} className="flex items-center gap-2.5 hover:text-emerald-400 transition-colors"><Mail size={16} className="text-emerald-400" /> {CONTACT.email}</a></li>
          <li className="flex items-center gap-2.5"><MapPin size={16} className="text-emerald-400" /> {CONTACT.location}</li>
          <li><a href={CONTACT.linkedinUrl} target="_blank" rel="noreferrer" className="flex items-center gap-2.5 hover:text-emerald-400 transition-colors"><Linkedin size={16} className="text-emerald-400" /> {CONTACT.linkedin}</a></li>
          <li className="flex items-start gap-2.5"><Clock size={16} className="text-emerald-400 mt-0.5" /> <span>{CONTACT.hoursDays}<br />{CONTACT.hoursTime}</span></li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-8 space-y-4">
        <p className="text-xs leading-relaxed text-slate-500 max-w-4xl">
          <strong className="text-slate-400">Important:</strong> Quantum Cover is an education and connection platform. Quantum Cover is not a licensed Financial Advice Provider and does not provide regulated financial advice. Insurance advice is provided by our licensed partner, Coversure. Information on this site is general in nature only.
        </p>
        <div className="flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} Quantum Cover. All rights reserved.</span>
          <span>Made with care in Aotearoa New Zealand.</span>
        </div>
      </div>
    </div>
  </footer>
);
